
    var riot = require('riot')
    import { Navigation } from './gb-navigation';
riot.tag2('gb-navigation', '<yield> <ul class="gb-side-nav"> <li data-is="gb-refinement-list" each="{navigation in $navigable.processed}"></li> </ul> </yield>', 'gb-navigation.gb-stylish > ul,[data-is="gb-navigation"].gb-stylish > ul{ padding: 12px; list-style: none; }', '', function(opts) {
    this._mixin(Navigation);
});

    
  


// WEBPACK FOOTER //
// ./src/tags/navigation/gb-navigation.tag.html